import type { BlockSettings } from '../grid/reduxStore/blockStyleSettingsSlice';
import type { SocketBlockSettings } from '../grid/reduxStore/saveHandlers';
import { DEFAULT_BLOCK_BORDER_COLOR } from '../shared/documentColorDefaults';
import { normalizeRotation } from '../GridDndEditor/helpers/rotation';

export function cleanStylesForPayload(styles: BlockSettings, blockId: string, updatedByUserId: number): SocketBlockSettings {
  return {
    blockId,
    updatedByUserId,
    currentTimestamp: new Date().toISOString(),
    borderLeft: styles.borderLeft ?? 0,
    borderRight: styles.borderRight ?? 0,
    borderTop: styles.borderTop ?? 0,
    borderBottom: styles.borderBottom ?? 0,
    borderRadius: styles.borderRadius ?? 0,
    paddingLeft: styles.paddingLeft ?? 0,
    paddingRight: styles.paddingRight ?? 0,
    paddingTop: styles.paddingTop ?? 0,
    paddingBottom: styles.paddingBottom ?? 0,
    borderColor: styles.borderColor ?? DEFAULT_BLOCK_BORDER_COLOR,
    ...(styles.backgroundColor !== undefined && { backgroundColor: styles.backgroundColor }),
    ...(styles.opacity !== undefined && { opacity: styles.opacity }),
    ...(styles.imageAlt !== undefined && { imageAlt: styles.imageAlt }),
    ...(styles.imageLink !== undefined && { imageLink: styles.imageLink }),
    ...(styles.imageAspectRatioLock !== undefined && { imageAspectRatioLock: styles.imageAspectRatioLock }),
    ...(styles.lockedBy !== undefined && { lockedBy: styles.lockedBy }),
    ...(styles.top !== undefined && { top: styles.top }),
    ...(styles.left !== undefined && { left: styles.left }),
    ...(styles.rotation !== undefined && { rotation: normalizeRotation(styles.rotation) }),
  };
}
